import { render, staticRenderFns } from "./TagManagementFilter.vue?vue&type=template&id=10713f82&"
import script from "./TagManagementFilter.vue?vue&type=script&lang=js&"
export * from "./TagManagementFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports